module.exports = __webpack_public_path__ + "static/img/4-4b.04329851.png";